import React from 'react';
import ServiceCard from '../molecules/ServiceCard';
import { motion } from 'framer-motion';

const ServicesSection = ({ setSelectedService }) => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    };

    return (
        <section id="services" className="py-24 bg-[#F9F7F2]">
            <div className="container mx-auto px-6">
                <div className="flex flex-col md:flex-row justify-between items-end mb-16">
                    <div>
                        <h2 className="serif text-4xl md:text-5xl mb-4">Our Menu</h2>
                        <p className="text-gray-500 max-w-md">Curated tiers designed for every level of expression.</p>
                    </div>
                    <button className="hidden md:block text-sm border-b border-black pb-1 hover:text-purple-700 transition-colors uppercase tracking-widest font-bold">View Full Price List</button>
                </div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={containerVariants}
                    className="grid md:grid-cols-3 gap-8"
                >
                    <motion.div variants={itemVariants}>
                        <ServiceCard
                            image="https://images.unsplash.com/photo-1519014816548-bf5fe059798b?auto=format&fit=crop&q=80&w=600"
                            duration="60 Mins"
                            title="The Minimalist"
                            price="$85+"
                            description="Clean structure, signature French, or solid color with chrome accents."
                            tier={1}
                            onSelect={() => {
                                setSelectedService('The Minimalist');
                                document.getElementById('booking').scrollIntoView({ behavior: 'smooth' });
                            }}
                        />
                    </motion.div>
                    <motion.div variants={itemVariants}>
                        <ServiceCard
                            image="https://images.unsplash.com/photo-1632345031435-8727f6897d53?auto=format&fit=crop&q=80&w=600"
                            tag="Best Seller"
                            title="The Elevated"
                            price="$145+"
                            description="Ombre, aura designs, isolated 3D textures, and simple hand-painted art."
                            tier={2}
                            onSelect={() => {
                                setSelectedService('The Elevated');
                                document.getElementById('booking').scrollIntoView({ behavior: 'smooth' });
                            }}
                        />
                    </motion.div>
                    <motion.div variants={itemVariants}>
                        <ServiceCard
                            image="https://images.unsplash.com/photo-1522337660859-02fbefca4702?auto=format&fit=crop&q=80&w=600"
                            duration="180 Mins"
                            title="The Masterpiece"
                            price="$250+"
                            description="Full custom heavy 3D, extreme lengths, liquid glass, and intricate painting."
                            tier={3}
                            onSelect={() => {
                                setSelectedService('The Masterpiece');
                                document.getElementById('booking').scrollIntoView({ behavior: 'smooth' });
                            }}
                        />
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default ServicesSection;
